import PropTypes from "prop-types";
import { useState } from "react";
import { List, Popover, Switch } from "antd";
import { InfoCircleOutlined, LogoutOutlined, UserOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { defaultColors } from '@/themes/antd-theme';
import { useShowAllScreens } from '@/menu-items/showAllScreens';

// ==============================|| HEADER PROFILE - PROFILE TAB ||============================== //

const ProfileTab = ({ handleLogout }) => {
  const navigate = useNavigate();
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [showAll, setShowAll] = useShowAllScreens();

  const handleListItemClick = (index) => {
    setSelectedIndex(index);
  };

  const handleUserProfile = () => {
    navigate("/user-profile");
  };

  const menuItems = [
    {
      key: 1,
      icon: <UserOutlined style={{ minWidth: 32, color: defaultColors.text.secondary }} />,
      text: "View Profile",
      onClick: () => {
        handleListItemClick(1);
        handleUserProfile();
      }
    },
    {
      key: 2,
      icon: <LogoutOutlined style={{ minWidth: 32, color: defaultColors.text.secondary }} />,
      text: "Logout",
      onClick: (e) => {
        handleLogout(e);
        setSelectedIndex(2);
      }
    }
  ];

  return (
    <>
    <div className="flex items-center gap-3 w-full p-2" data-testid="show-all-screens-row">
      <span style={{ minWidth: 32 }} />
      <span id="show-all-screens-label">Show all screens</span>
      <Popover
        trigger={['hover', 'click']}
        content={<div style={{ maxWidth: 260 }}>The menu shows the everyday screens. Turn this on to list every screen you have access to, including set-up, other dashboards, integrations and administration. Kept on this browser only.</div>}
      >
        <InfoCircleOutlined aria-label="About Show all screens" role="img" tabIndex={0} style={{ color: defaultColors.text.secondary }} />
      </Popover>
      <Switch size="small" className="ml-auto" checked={showAll} onChange={setShowAll} aria-labelledby="show-all-screens-label" data-testid="show-all-screens" />
    </div>
    <List
      dataSource={menuItems}
      renderItem={(item) => (
        <List.Item
          key={item.key}
          onClick={item.onClick}
          className={`cursor-pointer transition-colors px-0 ${selectedIndex === item.key ? 'bg-gray-50' : 'hover:bg-gray-50'}`}
          style={{ borderBottom: 'none' }}
        >
          <div className="flex items-center gap-3 w-full p-2">
            {item.icon}
            <span>{item.text}</span>
          </div>
        </List.Item>
      )}
    />
    </>
  );
};

ProfileTab.propTypes = {
  handleLogout: PropTypes.func,
};

export default ProfileTab;
